import { useState } from "react";
import { Client } from "../types";

interface ClientFormProps {
  initialData?: Partial<Client>;
  onSubmit: (data: Partial<Client>) => void;
  onCancel: () => void;
}

export default function ClientForm({ initialData, onSubmit, onCancel }: ClientFormProps) {
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    email: initialData?.email || "",
    phone: initialData?.phone || "",
    address: initialData?.address || "",
    company_name: initialData?.company_name || "",
    gst_number: initialData?.gst_number || "",
  });

  const set = (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setFormData(prev => ({ ...prev, [field]: e.target.value }));

  const inputCls = "w-full px-3 py-2.5 rounded-xl border border-stone-200 text-sm focus:border-amber-400 focus:ring-2 focus:ring-amber-100 outline-none";

  return (
    <form onSubmit={e => { e.preventDefault(); onSubmit(formData); }} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">Client Name *</label>
        <input type="text" value={formData.name} onChange={set("name")} placeholder="Enter client name" className={inputCls} required />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Email</label>
          <input type="email" value={formData.email} onChange={set("email")} placeholder="client@email.com" className={inputCls} />
        </div>
        <div>
          <label className="block text-xs font-medium text-stone-500 mb-1.5">Phone</label>
          <input type="tel" value={formData.phone} onChange={set("phone")} placeholder="+91 98765 43210" className={inputCls} />
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">Company Name</label>
        <input type="text" value={formData.company_name} onChange={set("company_name")} placeholder="Company/Business name (optional)" className={inputCls} />
      </div>

      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">Address</label>
        <textarea value={formData.address} onChange={set("address")} placeholder="Client address" rows={2} className={`${inputCls} resize-none`} />
      </div>

      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5">GST Number</label>
        <input type="text" value={formData.gst_number} onChange={set("gst_number")} placeholder="e.g., 27AABCU9603R1ZX" className={inputCls} />
      </div>

      <div className="flex gap-3 pt-2">
        <button type="button" onClick={onCancel} className="flex-1 px-4 py-2.5 rounded-xl bg-stone-100 text-stone-600 font-semibold text-sm hover:bg-stone-200 transition-colors border border-stone-200">
          Cancel
        </button>
        <button type="submit" className="flex-1 px-4 py-2.5 rounded-xl text-white font-semibold text-sm gold-gradient hover:opacity-90 transition-opacity">
          {initialData?.id ? "Update" : "Add"} Client
        </button>
      </div>
    </form>
  );
}
